<!--
 * @description: 型号信息
 * @param: 
 * @return: 
-->
<template>
  <div class="user-management-container">
    <tabel-panel
      ref="tabel"
      :rowTemplate="rowTemplate"
      api="ModelNoSelect"
      editType="pop"
      :condition="conditionData"
      @popConfirmButtonClick="popConfirmButtonClick"
      :clickRowSelected="false"
      :autoSearch="true"
    >
      <template v-slot:tabelTitleRight>
        <add-button @buttonClick="add">新增</add-button>
      </template>
      <template v-slot:tabelTitleLeft>
        <div>型号信息</div>
      </template>
      <template v-slot:condition>
        <text-field
          v-model:value="conditionData.BrandId"
          labelText="品牌名称"
          type="select"
          :clearable="true"
          :selectRemoteSearchData="selectOuguName"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.ProductId"
          labelText="产品类别:"
          ref="selectChild"
          :clearable="true"
          :type="selectChildData == null ? 'select' : 'selectChild'"
          :selectChildData="selectChildData"
          :selectRemoteSearchData="selectOuguNameProduct"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.ModelNoStr"
          labelText="型号"
          class="condition-container-input"
        >
        </text-field>
      </template>

      <template v-slot:checkBox01="$opData">
        <el-checkbox v-model="$opData.data.row.State"></el-checkbox>
      </template>

      <template v-slot:oprator="$opData">
        <div class="opration">
          <div class="style-aaa" @click="deleteUser($opData.data)">删除</div>
          <!-- <del-border
						:useConfirm="true" comfirmMessage="确定删除吗？" 
						comfirmOkText="确定" comfirmCancelText="取消" 
						@buttonClick="deleteUser($opData.data)"></del-border> -->
        </div>
      </template>
    </tabel-panel>
  </div>
</template>

<script>
import { ElMessageBox } from "element-plus";
import textField from "@/components/textField.vue";
import delButton from "@/components/delButton.vue";
import addButton from "@/components/addButton.vue";
import updateButton from "@/components/updateButton.vue";
import tabelPanel from "@/components/tabelPanel.vue";
import popDialog from "@/components/popDialog.vue";
import delBorder from "@/components/delBorder.vue";
import tableApi from "@/api/tabel.js";
import { modelEdit, modelDel } from "@/api/index.js";
import { errMsg, successMsg } from "@/notify/index.js";

export default {
  name: "modelInfo",
  components: {
    delBorder,
    tabelPanel,
    textField,
    delButton,
    addButton,
    popDialog,
  },
  data() {
    const selectValueFn = (v, item) => {
      if (item) {
        return item.BrandId;
      }
    };
    const selectRemoteSearchData = async () => {
      let source = await tableApi.BrandSelect();
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(source.message);
      }
    };

    const selectRemoteSearchData2 = async (
      pageSize,
      currentPageIndex,
      parms
    ) => {
      //产品select列表
      console.log("parms.BrandId", parms.BrandId);
      if (parms.BrandId == null || parms == null) {
        return {
          total: 0,
          data: null,
        };
      }
      let source = await tableApi.ProductSelect({ Bid: parms.BrandId });
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(source.message);
      }
    };
    // 是否巡检
    const selectFn = (v, item) => item.id;
    const selectRemoteData = () => {
      let obj = {
        total: 0,
        data: [
          {
            label: "是",
            value: 1,
          },
          {
            label: "否",
            value: 0,
          },
        ],
      };
      return obj;
    };
    return {
      queryShow: false,
      rowTemplate: [
        {
          headerLabel: "品牌名称",
          dataIndex: "BrandName",
          sortable: true,
          editType: "text",
        },
        {
          headerLabel: "品牌名称",
          dataIndex: "BrandId",
          editable: true,
          selectRemoteSearchData,
          selectValueFn,
          editType: "select",
          rules: [
            {
              required: true,
              message: "请选择品牌",
            },
          ],
          showInList: false,
        },
        {
          headerLabel: "产品类别名称",
          sortable: true,
          dataIndex: "ProductName",
        },
        {
          headerLabel: "产品类别名称",
          dataIndex: "ProductId",
          editable: true,
          selectRemoteSearchData: selectRemoteSearchData2,
          refKey: "BrandId",
          editType: "select",
          rules: [
            {
              required: true,
              message: "请输入品牌名",
            },
          ],
          showInList: false,
        },
        {
          headerLabel: "型号",
          editable: true,
          sortable: true,
          dataIndex: "ModelNoStr",
        },
        {
          headerLabel: "巡检状态",
          editable: true,
          sortable: true,
          dataIndex: "State",
          editType: "checkbox",
          dataRender: (v) => {
            if (v == true) {
              return "是";
            } else if (v == false) {
              return "否";
            } else {
              return ["是"];
            }
          },
          fieldData: [
            {
              label: "巡检",
              value: true,
            },
          ],
          // fieldData: [ {
          // 	label: "是",
          // 	value: true
          // 	},{
          // 	label:"否",
          // 	value:false
          // }]

          // headerLabel: "是否启用",
          // dataIndex: "IsEnable",
          // showInDetail: true,
          // dataRender: (v) => {
          // 	if (v == true) {
          // 	return "是";
          // 	} else if (v == false) {
          // 	return "否";
          // 	} else {
          // 	return v;
          // 	}
          // },
        },
        {
          headerLabel: "备注",
          editable: true,
          editType: "textarea",
          dataIndex: "Appendix",
          rows: 2,
        },
        {
          headerLabel: "操作",
          width: 140,
          slot: "oprator",
        },
      ],
      conditionData: {
        BrandId: null,
        ModelNoStr: "",
        ProductId: null,
      },
      selectChildData: null,
    };
  },
  watch: {
    "conditionData.BrandId"(newV, oldV) {
      this.$refs.selectChild.stringValue = "";
      if (newV) {
        this.selectOuguNameProduct(newV);
        return;
      }
      this.selectChildData = null;
    },
  },
  methods: {
    async selectOuguName() {
      let source = await tableApi.BrandSelect();
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    async selectOuguNameProduct(newV) {
      let source;
      if (this.selectChildData == null) {
        source = await tableApi.ProductSelect();
      } else {
        source = await tableApi.ProductSelect({ Bid: newV });
      }

      this.selectChildData = source.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(source.message);
      }
    },
    reloadData() {
      this.$refs.tabel.reloadData();
    },
    add() {
      this.$refs.tabel.showDialog();
    },
    // del-user
    deleteUser({ row }) {
      let id = row.id;
      ElMessageBox.confirm("确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          modelDel({
            id,
          }).then((data) => {
            if (data.code == 0) {
              successMsg(data.message);
              this.reloadData();
            } else {
              errMsg(data.message);
            }
          });
        })
        .catch(() => {});
    },
    // 新加，修改-user
    popConfirmButtonClick({ slotData }) {
      if (slotData.id === null) {
        slotData.id = 0;
      }
      slotData.State = slotData.State != undefined ? slotData.State[0] : false;
      if (slotData.id != 0) {
        let { id, ProductId, ModelNoStr, State, Appendix } = slotData;
        modelEdit({ id, ProductId, ModelNoStr, State, Appendix }).then(
          (data) => {
            if (data.code == 0) {
              successMsg(data.message);
              this.reloadData();
              this.$refs.tabel.closeDialog();
            } else {
              errMsg(data.message);
            }
          }
        );
      } else {
        let { ProductId, ModelNoStr, State, Appendix } = slotData;
        modelEdit({ ProductId, ModelNoStr, State, Appendix }).then((data) => {
          if (data.code == 0) {
            successMsg(data.message);
            this.reloadData();
            this.$refs.tabel.closeDialog();
          } else {
            errMsg(data.message);
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

.user-management-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-items: center;
  align-content: center;
  @include background_color("user-management-bg-color");

  .search-button-icon {
    background: none;
  }

  .del {
    margin-left: 10px;
  }

  .condition-container-input {
    width: 270px;
  }

  .opration {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    .item {
      &:nth-child(n + 1) {
        margin-left: 10px;
      }
    }
  }

  ::v-deep
    .text-field-container
    .text-field-container-input-container
    .checkbox-group
    .checkbox-group-item {
    margin-left: 10px;
  }
}
.style-aaa {
  cursor: pointer;
  color: rgb(100, 134, 232);
  // style="{cursor:'pointer',color:'rgb(100,134,232)'}"
}
</style>
